<template>
  <div v-if="current" class="site-announcement" role="presentation" @click.self="dismiss">
    <section class="announcement-dialog" role="dialog" aria-modal="true" aria-labelledby="announcement-title">
      <button type="button" class="announcement-close" title="关闭公告" aria-label="关闭公告" @click="dismiss">&#215;</button>
      <div class="announcement-mark" aria-hidden="true">公告</div>
      <div class="announcement-copy">
        <span class="announcement-kicker">SITE NOTICE</span>
        <h2 id="announcement-title">{{ current.title }}</h2>
        <p>{{ current.content }}</p>
      </div>
      <router-link v-if="link && !external" class="announcement-link" :to="link">{{ current.buttonText }}</router-link>
      <a v-else-if="link" class="announcement-link" :href="link" target="_blank" rel="noopener noreferrer">{{ current.buttonText }}</a>
      <div v-if="visible.length > 1" class="announcement-controls">
        <button type="button" title="上一条公告" aria-label="上一条公告" @click="move(-1)">&#8249;</button>
        <span>{{ index + 1 }} / {{ visible.length }}</span>
        <button type="button" title="下一条公告" aria-label="下一条公告" @click="move(1)">&#8250;</button>
      </div>
    </section>
  </div>
</template>

<script>
import { videoApi } from '@/api/video'
import { announcementLink, announcementKey } from '@/utils/announcement'

export default {
  name: 'SiteAnnouncement',
  data () { return { items: [], dismissed: [], index: 0, busy: false, timer: null, disposed: false } },
  computed: {
    visible () {
      return this.items.filter(item => (item.displayScope === 'ALL' || (item.displayScope === 'HOME' && this.$route.path === '/')) && this.dismissed.indexOf(announcementKey(item)) < 0)
    },
    current () { return this.visible[this.index] || this.visible[0] || null },
    link () { return this.current && this.current.buttonText ? announcementLink(this.current.targetUrl) : '' },
    external () { return /^https?:/i.test(this.link) }
  },
  watch: {
    '$route.path' () { this.index = 0 },
    visible () { if (this.index >= this.visible.length) this.index = 0 }
  },
  mounted () {
    try {
      const saved = JSON.parse(sessionStorage.getItem('video_announcements_dismissed') || '[]')
      this.dismissed = Array.isArray(saved) ? saved.slice(-100) : []
    } catch (e) { this.dismissed = [] }
    this.refresh()
    this.timer = window.setInterval(this.refresh, 60000)
    document.addEventListener('visibilitychange', this.refresh)
    document.addEventListener('keydown', this.onKeydown)
    document.body.classList.add('announcement-open')
  },
  beforeDestroy () {
    this.disposed = true
    window.clearInterval(this.timer)
    document.removeEventListener('visibilitychange', this.refresh)
    document.removeEventListener('keydown', this.onKeydown)
    document.body.classList.remove('announcement-open')
  },
  methods: {
    refresh () {
      if (this.busy || this.disposed || document.hidden) return
      this.busy = true
      return videoApi.announcements().then(rows => {
        if (this.disposed) return
        this.items = Array.isArray(rows) ? rows : []
      }).catch(() => {
        // Do not retain possibly withdrawn notices when a refresh fails.
        if (!this.disposed) this.items = []
      }).finally(() => { this.busy = false })
    },
    move (step) { if (this.visible.length) this.index = (this.index + step + this.visible.length) % this.visible.length },
    onKeydown (event) { if (event.key === 'Escape' && this.current) this.dismiss() },
    dismiss () {
      if (!this.current) return
      this.dismissed = this.dismissed.concat(announcementKey(this.current)).slice(-100)
      this.index = 0
      try { sessionStorage.setItem('video_announcements_dismissed', JSON.stringify(this.dismissed)) } catch (e) { /* Storage may be disabled. */ }
      document.body.classList.remove('announcement-open')
    }
  }
}
</script>

<style scoped>
.site-announcement{position:fixed;inset:0;z-index:1000;display:grid;place-items:center;padding:24px;background:rgba(3,5,8,.76);backdrop-filter:blur(8px);color:#eef1f5}
.announcement-dialog{position:relative;width:min(560px,100%);padding:42px 42px 34px;border:1px solid rgba(240,68,56,.35);border-radius:10px;background:linear-gradient(145deg,#1a1d24,#101216);box-shadow:0 24px 80px rgba(0,0,0,.55);overflow:hidden}
.announcement-dialog:before{content:'';position:absolute;inset:0 0 auto;height:3px;background:var(--brand,#f04438)}
.announcement-close{position:absolute;top:12px;right:14px;width:34px;height:34px;border:0;border-radius:50%;background:transparent;color:#9ba3ae;font-size:25px;line-height:1;cursor:pointer}.announcement-close:hover{background:#2c3038;color:#fff}
.announcement-close:focus-visible,.announcement-link:focus-visible,.announcement-controls button:focus-visible{outline:2px solid var(--brand,#f04438);outline-offset:3px}
.announcement-mark{display:inline-flex;align-items:center;justify-content:center;width:52px;height:52px;margin-bottom:20px;border-radius:50%;background:rgba(240,68,56,.14);color:#ff8c80;font-size:13px}
.announcement-kicker{display:block;margin-bottom:8px;color:#929ba8;font-size:10px;letter-spacing:2px}.announcement-copy h2{margin:0;color:#fff;font-size:24px;line-height:1.35}.announcement-copy p{margin:14px 0 0;color:#bac1cb;font-size:14px;line-height:1.8;white-space:pre-wrap;overflow-wrap:anywhere}
.announcement-link{display:inline-flex;align-items:center;justify-content:center;min-height:38px;margin-top:24px;padding:0 18px;border-radius:5px;background:var(--brand,#f04438);color:#fff;font-size:13px;text-decoration:none}.announcement-link:hover{filter:brightness(1.08)}
.announcement-controls{display:flex;align-items:center;gap:8px;margin-top:22px;color:#818a96;font-size:12px}.announcement-controls button{width:28px;height:28px;border:1px solid #343a45;border-radius:4px;background:#1d2129;color:#d7dce3;font-size:19px;line-height:1;cursor:pointer}.announcement-controls button:hover{border-color:var(--brand,#f04438);color:#fff}
@media(max-width:640px){.site-announcement{padding:16px}.announcement-dialog{padding:36px 24px 26px}.announcement-copy h2{font-size:20px}}
</style>



// WEBPACK FOOTER //
// src/components/SiteAnnouncement.vue